import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=5677ce5f&scoped=true&"
var script = {}
import style0 from "./Main.vue?vue&type=style&index=0&id=5677ce5f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5677ce5f",
  null
  
)

export default component.exports